import { useMemo } from 'react';
import { ProductDto } from 'desk-common';

export const useProductsMap = (products: ProductDto[] = []) => {
  return useMemo<Map<number, ProductDto>>(
    () => new Map(products.map((p: ProductDto) => [p.id, p])),
    [products]
  );
};
